import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';
import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { ProfileTableComponent } from './components/profile-table/profile-table.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { USER_PROFILE_FEATURE } from './store/user-profile.state';
import { UserProfileReducer } from './store/reducers';
import { UserProfileEffects } from './store/effects/user-profile.effects';
import { UserProfileEffectsService } from './store/effects/user-profile.effects.service';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}
@NgModule({
  declarations: [
    ProfileDetailsComponent,
    ProfileTableComponent,
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    FormsModule,
    SGRESharedModule,
    ReactiveFormsModule,
    StoreModule.forFeature(USER_PROFILE_FEATURE, UserProfileReducer),
    EffectsModule.forFeature(UserProfileEffects),
    ConfigModule.withConfig({
      cmsComponents: {
        UserProfileDetailsComponent: {
          component: () => import('./components/profile-details/profile-details.component').then(m => m.ProfileDetailsComponent),
          guards: [CustomRouteGuard]
        },
        UserProfileTableComponent: {
          component: () => import('./components/profile-table/profile-table.component').then(m => m.ProfileTableComponent),
          guards: [CustomRouteGuard]
        },
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    UserProfileEffectsService,
    { provide: TranslateStore }
  ]
})
export class USerProfileModule { }